import BASE_URL from "../../shared/base-url"

export const SETTINGS_ENDPOINT = {
  detail: `${BASE_URL}/configurations/get-configurations`,
  update: `${BASE_URL}/configurations/update-configuration`,
  toggleConfidentiality: `${BASE_URL}/owners/update-confidentiality`,
}
